import { render, staticRenderFns } from "./fixed-asset.vue?vue&type=template&id=f0eb130e&"
import script from "./fixed-asset.vue?vue&type=script&lang=js&"
export * from "./fixed-asset.vue?vue&type=script&lang=js&"
import style0 from "./fixed-asset.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports